<svg:g [style.opacity]="window.opacity">
    <rect
        [attr.height]="window.height"
        [attr.width]="window.width"
        [attr.x]="window.x"
        [attr.y]="window.y"
        class="window"
        id="window"
    ></rect>

    <text
        (click)="onRemoveClick()"
        [attr.height]="5"
        [attr.width]="5"
        [attr.x]="window.x + window.width - 5"
        [attr.y]="window.y"
        class="material-remove remove"
    >
        close
    </text>
    <text [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 4" class="measures-text">
        A1 {{ measures.A1 | number: "1.2-2" }}
    </text>
    <text [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 10" class="measures-text">
        A2 {{ measures.A2 | number: "1.2-2" }}
    </text>
    <text [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 16" class="measures-text">
        &Delta;A {{ measures.deltaA | number: "1.2-2" }}
    </text>
    <text [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 22" class="measures-text">
        &Delta;T {{ measures.deltaT | number: "1.0-0" }}
    </text>
    <text [attr.x]="window.x + window.width + 5" [attr.y]="window.y + 28" class="measures-text">
        HR {{ measures.HR | number: "1.0-0" }}
    </text>
</svg:g>
